/**
 * Format a credit amount for display, avoiding floating-point artifacts (e.g. -2.4810000000000003).
 * Rounds to up to 6 decimal places and trims trailing zeros.
 */
export function formatCreditAmount(n: number): string {
  const rounded = Math.round(n * 1e6) / 1e6;
  const s = rounded.toFixed(6).replace(/\.?0+$/, '');
  return s;
}
